export default __webpack_public_path__ + "static/media/Alex.701bc5cb.jpg";